import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useLiquidity } from "../../hooks/useLiquidity";
import secretLogo from "../../assets/images/secret_swap_2.png";
import MoonLoader from "react-spinners/MoonLoader";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { formatCompactNumber } from "../../utils/common";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userLiqDataState } from "../../context/userLiqDataState";
import { PulseLoader } from "react-spinners";
// import { SkeletonTheme } from "react-loading-skeleton/dist/SkeletonTheme";

const PairCard = ({ t1, t2, pairs, userLiq1, userBondedAmount1, poolAPR1 }: any) => {
  // console.log("user", pairs.pair_name, userLiq1, userBondedAmount1, poolAPR1)
  const {
    getPoolUserAmount,
    getPoolTotalAmount,
    getPoolUserBonded,
    getPoolAPR,
  } = useLiquidity();
  const [totalLiq, setTotalLiq] = useState("");
  const [userLiq, setUserLiq] = useState("");
  const [userBondedAmount, setUserBondedAmount] = useState("");
  const [poolAPR, setPoolAPR] = useState("");
  const [isloading, setIsLoading] = useState(true);
  const [isloading2, setIsLoading2] = useState(true);


  const userData = useRecoilValue(userLiqDataState);
  const setUserData = useSetRecoilState(userLiqDataState);

  const getPools = async () => {
    const { userAmount } = await getPoolUserAmount(pairs.pair_name);
    setUserLiq(userAmount);
    setIsLoading(false);

    const { totalAmount } = await getPoolTotalAmount(pairs.pair_name);
    setTotalLiq(totalAmount);

    const { userDollarBonded } = await getPoolUserBonded(pairs.pair_name);
    setUserBondedAmount(userDollarBonded);

    const poolAPR = await getPoolAPR(pairs.pair_name);
    setPoolAPR(poolAPR.apr);
    
    setUserData({
      uAmount: userAmount,
      tAmount: totalAmount,
      uBonded: userDollarBonded,
      apr: poolAPR.apr,
    })
    setIsLoading2(false);
  };

  useEffect(() => {
    // setIsLoading(true);
    setIsLoading(false);
    
    if(userData.uAmount === ""){
      getPools();
    }
    else {
      setUserLiq(userData.uAmount);
      setIsLoading(false);
      setPoolAPR(userData.apr);
      setTotalLiq(userData.tAmount);
      setUserBondedAmount(userData.uBonded);
    }
  }, []);

  useEffect(()=>{
    const checkuserData = async()=>{
      const { userAmount } = await getPoolUserAmount(pairs.pair_name);
      if(userAmount !== userData.uAmount){
        // setIsLoading2(true);
        getPools();
      }
      else setIsLoading2(false);
    }
    checkuserData();
  }, [])

  const display = pairs.pair_type === "stable";
  if (!Number(userLiq) && !isloading) {
    return <></>;
  } else
    return (
      <>
        {isloading ? (
          <>
            <div className="card">
              <SkeletonTheme baseColor="#6046D2" highlightColor="#A500A8">
                <h1>
                  <Skeleton width="190px" height="50px" />
                </h1>
                <p>
                  <Skeleton count={4} width="190px" />
                </p>
              </SkeletonTheme>
            </div>
          </>
        ) : (
          <div className="card">
            <div className="card-image">
              <div className="overlapping-images">
                <img src={t1?.logo_URIs.png} alt="" height={50} width={50} />
                <img
                  className="logo-overlap"
                  src={t2?.logo_URIs.png}
                  alt=""
                  height={50}
                  width={50}
                />
              </div>
              <div className="pair_name">
                <div>
                  {t1.display_denom} / {t2.display_denom}
                </div>{" "}
                {display ? (
                  <div className="display-tag">
                    <span>stable</span>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            {/* <div className="card-content">
        <span>Your Liquidity</span>
        <p className="numeric-font">${userLiq}</p>
      </div> */}
            <div className="card-bottom">
              <div>
                <span>Bonded</span>
                {/* <p className="numeric-font">${userBondedAmount}</p> */}
                <p className="numeric-font">
                {
        //           isloading2 ?
        //           <PulseLoader
        //   color="#1790FF"
        //   loading={true}
        //   // cssOverride={override}
        //   size={10}
        //   aria-label="Loading Spinner"
        //   data-testid="loader"
        // />
        //           :
        //           Number(userBondedAmount) === 0?
        //           "0.00"
        //           :
                  "$"+formatCompactNumber(userBondedAmount1)
                }
                </p>
              </div>

              <div>
                <span>Your Liquidity</span>
                {/* <p className="numeric-font">${userLiq}</p> */}
                <p className="numeric-font">{
        //           isloading2 ?
        //           <PulseLoader
        //   color="#1790FF"
        //   loading={true}
        //   // cssOverride={override}
        //   size={10}
        //   aria-label="Loading Spinner"
        //   data-testid="loader"
        // />
        //           :
        "$"+formatCompactNumber(userLiq1)
                }</p>
              </div>

              {/* <div>
          <span>Rewards</span>
          <p><img className="reward-logo-img" src={secretLogo}/></p>
        </div> */}
              <div>
                <span>APR</span>
                <p className="numeric-font">
                {
                  // isloading2 ?
        //           <PulseLoader
        //   color="#1790FF"
        //   loading={true}
        //   // cssOverride={override}
        //   size={10}
        //   aria-label="Loading Spinner"
        //   data-testid="loader"
        // />
        //           :
                  poolAPR1 ? poolAPR1 + "%": "0.00%"
                }
                </p>
              </div>
            </div>
          </div>
        )}
      </>
    );
};

export default PairCard;













/*
const myObjectKey = pairs.pair_name;
    const currentPairData = userLiqData.userLiqDataMap[pairs.pair_name];

    const updatedPairData = {
      ...currentPairData,
      uAmount: userAmount,
      tAmount: totalAmount,
      uBonded: userDollarBonded,
      apr: poolAPR.apr,
    };
    setCallme(!callme);
    console.log("here updated", userLiqData.userLiqDataMap[pairs.pair_name].uAmount, pairs.pair_name, userAmount);
    setUserLiqData({
      ...userLiqData,
      userLiqDataMap: {
        ...userLiqData.userLiqDataMap,
        [myObjectKey]: updatedPairData,
      },
    })
*/

































// import React, { useEffect, useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
// import { useLiquidity } from "../../hooks/useLiquidity";
// import secretLogo from "../../assets/images/secret_swap_2.png";
// import MoonLoader from "react-spinners/MoonLoader";
// import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { formatCompactNumber } from "../../utils/common";
// import { useRecoilValue, useSetRecoilState } from "recoil";
// import { userLiqDataState } from "../../context/userLiqDataState";
// // import { SkeletonTheme } from "react-loading-skeleton/dist/SkeletonTheme";

// const PairCard = ({ t1, t2, pairs }: any) => {
//   const {
//     getPoolUserAmount,
//     getPoolTotalAmount,
//     getPoolUserBonded,
//     getPoolAPR,
//   } = useLiquidity();
//   const [totalLiq, setTotalLiq] = useState("");
//   const [userLiq, setUserLiq] = useState("");
//   const [userBondedAmount, setUserBondedAmount] = useState("");
//   const [poolAPR, setPoolAPR] = useState("");
//   const [isloading, setIsLoading] = useState(true);


//   let userData = useRecoilValue(userLiqDataState);
//   const setUserData = useSetRecoilState(userLiqDataState);

//   const getPools = async () => {
//     const { userAmount } = await getPoolUserAmount(pairs.pair_name);
//     setUserLiq(userAmount);
//     setIsLoading(false);

//     const { totalAmount } = await getPoolTotalAmount(pairs.pair_name);
//     setTotalLiq(totalAmount);

//     const { userDollarBonded } = await getPoolUserBonded(pairs.pair_name);
//     setUserBondedAmount(userDollarBonded);

//     const poolAPR = await getPoolAPR(pairs.pair_name);
//     setPoolAPR(poolAPR.apr);
//     let uDataMap: Record<string, any> = {userData};
//       uDataMap[pairs.pair_name] = {
//         uAmount: userAmount,
//         tAmount: totalAmount,
//         uBonded: userDollarBonded,
//         apr: poolAPR.apr,
//       };
//     setUserData({
//       udata: {
//         uDataMap
//       }
//     })
//     console.log(userData, "hee");
//   };

//   useEffect(() => {
//     setIsLoading(true);
//     console.log(userData, "heloo")
//     if(!userData.udata[pairs.pair_name] || userData.udata[pairs.pair_name]?.uAmount === ""){
//       getPools();
//     }
//     else {
//       setUserLiq(userData.udata[pairs.pair_name].uAmount);
//       setIsLoading(false);
//       setPoolAPR(userData.udata[pairs.pair_name].apr);
//       setTotalLiq(userData.udata[pairs.pair_name].tAmount);
//       setUserBondedAmount(userData.udata[pairs.pair_name].uBonded);
//     }
//   }, []);

//   useEffect(()=>{
//     const checkuserData = async()=>{
//       const { userAmount } = await getPoolUserAmount(pairs.pair_name);
//       if(!userData.udata[pairs.pair_name] || userAmount !== userData.udata[pairs.pair_name].uAmount){
//         // console.log(userAmount, userData.udata[pairs.pair_name].uAmount);
//         getPools();
//       }
//     }
//     checkuserData();
//   }, [])

//   const display = pairs.pair_type === "stable";
//   if (!Number(userLiq) && !isloading) {
//     return <></>;
//   } else
//     return (
//       <>
//         {isloading ? (
//           <>
//             <div className="card">
//               <SkeletonTheme baseColor="#6046D2" highlightColor="#A500A8">
//                 <h1>
//                   <Skeleton width="190px" height="50px" />
//                 </h1>
//                 <p>
//                   <Skeleton count={4} width="190px" />
//                 </p>
//               </SkeletonTheme>
//             </div>
//           </>
//         ) : (
//           <div className="card">
//             <div className="card-image">
//               <div className="overlapping-images">
//                 <img src={t1?.logo_URIs.png} alt="" height={50} width={50} />
//                 <img
//                   className="logo-overlap"
//                   src={t2?.logo_URIs.png}
//                   alt=""
//                   height={50}
//                   width={50}
//                 />
//               </div>
//               <div className="pair_name">
//                 <div>
//                   {t1.display_denom} / {t2.display_denom}
//                 </div>{" "}
//                 {display ? (
//                   <div className="display-tag">
//                     <span>stable</span>
//                   </div>
//                 ) : (
//                   <></>
//                 )}
//               </div>
//             </div>
//             {/* <div className="card-content">
//         <span>Your Liquidity</span>
//         <p className="numeric-font">${userLiq}</p>
//       </div> */}
//             <div className="card-bottom">
//               <div>
//                 <span>Bonded</span>
//                 {/* <p className="numeric-font">${userBondedAmount}</p> */}
//                 <p className="numeric-font">
//                   ${formatCompactNumber(userBondedAmount)}
//                 </p>
//               </div>

//               <div>
//                 <span>Your Liquidity</span>
//                 {/* <p className="numeric-font">${userLiq}</p> */}
//                 <p className="numeric-font">${formatCompactNumber(userLiq)}</p>
//               </div>

//               {/* <div>
//           <span>Rewards</span>
//           <p><img className="reward-logo-img" src={secretLogo}/></p>
//         </div> */}
//               <div>
//                 <span>APR</span>
//                 <p className="numeric-font">{poolAPR}%</p>
//               </div>
//             </div>
//           </div>
//         )}
//       </>
//     );
// };

// export default PairCard;
